import { render, staticRenderFns } from "./dangerStorageCheckItem.vue?vue&type=template&id=8847f2f4"
import script from "./dangerStorageCheckItem.vue?vue&type=script&lang=js"
export * from "./dangerStorageCheckItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8847f2f4')) {
      api.createRecord('8847f2f4', component.options)
    } else {
      api.reload('8847f2f4', component.options)
    }
    module.hot.accept("./dangerStorageCheckItem.vue?vue&type=template&id=8847f2f4", function () {
      api.rerender('8847f2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/base/dangerStorageCheckItem.vue"
export default component.exports